import { SideNav, SideNavContent } from "components";
import PageHeader from "components/UniversalComponents/PageHeader";
import { HeaderDasNew, MainBody, OverlayLoader, Ptag } from "components/core";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import http from "services/httpService";
import { ClaimsDetailedRow, DetailedRow, DetailedTable } from "../../Claims/EmployeeDetail/style";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { formatToRupees } from "utlis/utils";
import { startCase, toLower } from "lodash";
import BaseBreadcrumbs from "components/core/BaseBreadcrumbs";
import { EmpClaimsTableName, EmpClaimsTableValue } from "./styles";

function EmployeeDetail() {
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const companyName = localStorage.getItem("company_name");
  const [tableData, setTableData] = useState();
  useEffect(async () => {
    try {
      const payload = pathname.split("/").pop();
      const { data } = await http.get("/business/get_claims_employee_data/", {
        params: {
          row_id: payload,
        },
      });
      setTableData(data);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const crumbs = useMemo(() => {
    return [
      {
        name: "Claims",
        path: "/v1/claims",
      },
      {
        name: "Claim MIS",
        path: "/v1/claims/mis",
      },
      {
        name: "Detailed Summary",
        active: true,
      },
    ];
  }, []);

  return (
    <>
      <BaseBreadcrumbs breadcrumbs={crumbs} />
      {/* <WidthLimiter style={{ paddingLeft: "12px" }}> */}
      <>
        <DetailedTable>
          {tableData?.map(({ name, value }) => {
            // Skip rendering the "Balance Sum Insured" row if there's no value
            if (name === "Balance Sum Insured" && (!value || value === "0")) {
              return null;
            }

            const wordsToCapitalize = [
              "Employee Name",
              "Patient Name",
              "Hospital Name",
              "Hospital City",
              "Hospital State",
              "Claim Type",
              "Claim Status",
            ];
            if (wordsToCapitalize.includes(name)) {
              value = startCase(toLower(value));
            }

            return (
              <tr key={name}>
                <div style={{ width: "30%", padding: "26px 0px 26px 36px", width: "100%" }}>
                  {/* <Ptag fontWeight="500" fontSize="14px">
                    {name}
                  </Ptag> */}
                  <EmpClaimsTableName>
                    {name}
                  </EmpClaimsTableName>
                </div>
                {value && value !== "0" ? (
                  <ClaimsDetailedRow>
                    <Ptag fontWeight="500" fontSize="14px">
                      {[
                        "Sum Insured",
                        "Claim Amount",
                        "Balance Sum Insured",
                        "Paid Amount",
                      ].includes(name)
                        ? <EmpClaimsTableValue>{formatToRupees(value)}</EmpClaimsTableValue>
                        : <EmpClaimsTableValue>{value}</EmpClaimsTableValue>}
                    </Ptag>
                  </ClaimsDetailedRow>
                ) : (
                  <ClaimsDetailedRow>
                    <EmpClaimsTableValue>
                      {"-"}
                    </EmpClaimsTableValue>
                  </ClaimsDetailedRow>
                )}
              </tr>
            );
          })}
        </DetailedTable>
      {/* </WidthLimiter> */}
      </>
    </>
  );
}

export default EmployeeDetail;
